const relatedLinks = require("./GeneratedToolDemoRelatedLinks.json")
const {getAllToolDemoPageDefinitions} = require("./ToolDemoPageCatalog")
const pagesBySlug = new Map(getAllToolDemoPageDefinitions().map(definition => [definition.slug, definition]))

const labels = {framework: "Framework", toolType: "Type", workflow: "Use", topic: "Focus", population: "Population"}
function getToolDemoTagGroups(page) {
	return Object.entries(labels).filter(([key]) => page.tags?.[key]?.length).map(([key, label]) => ({key, label, values: page.tags[key]}))
}
function getToolDemoTagLabels(page) {
	const seen = new Set()
	return getToolDemoTagGroups(page).flatMap(group => group.values).map(value => value.trim()).filter(label => {
		const key = label.toLowerCase()
		if (!key || seen.has(key)) return false
		seen.add(key)
		return true
	})
}
function getRelatedToolDemoPages(page) {
	return (relatedLinks[page.slug] || []).map(slug => pagesBySlug.get(slug)).filter(Boolean)
}
module.exports = {getToolDemoTagGroups, getToolDemoTagLabels, getRelatedToolDemoPages}
